import { Link } from "react-router-dom";
import { trackEvent } from "../../../analytics";

const InvestmentOption = ({ investmentData }: any) => {
  const formatNameForTracking = (name: string): string => {
    const firstWord = name.split(" ")[0].toLowerCase();
    return `fd_${firstWord}`;
  };
  return (
    <div className="rounded-[12px] w-full bg-white p-6">
      <div className="flex items-center gap-2">
        <h1 className="text-[22px] font-bold">Fixed Deposit</h1>
        <img
          src="/assets/money/investmentOptions.png"
          alt="investment options"
          className="w-fit h-[11.5px] object-cover"
        />
      </div>
      <div className="flex gap-4 flex-wrap justify-start mt-4">
        {investmentData.map((item: any, index: number) => (
          <div
            key={index}
            className="flex flex-col items-start p-4 border-[1px] rounded-[10px] w-[270px] h-[180px] shadow-[0_0_15px_0_rgba(0,0,0,0.1)] relative"
          >
            {item?.tag?.description && (
              <div className="absolute bg-[#d1c6ff] text-[12px] text-[#661eff] px-3 py-1 rounded-full top-0 -translate-y-[50%] left-[50%] -translate-x-[50%]">
                {item.tag.description}
              </div>
            )}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
              <img
                src="/assets/money/topology-design.webp"
                alt="design"
                className="absolute top-12 left-[120px] z-0 pointer-events-none"
              />
            </div>
            <div className="flex items-center gap-4">
              <img
                src={item.image_url}
                alt={item.title}
                className="w-[40px] h-[40px] object-cover"
              />
              <div className="font-bold">
                <h1>{item.name}</h1>
              </div>
            </div>
            <h3 className="text-[12px] font-[500] mt-[20px]">upto</h3>
            <div className="flex items-end gap-1 text-[12px]">
              <h2 className="text-[22px] font-bold">{item.return}%</h2>
              p.a.
            </div>
            <Link
              to={item.redirect_url}
              onClick={() => {
                trackEvent("invest_cta_clicked", {
                  cta_for: formatNameForTracking(item.name),
                });
              }}
            >
              <button className="relative bg-[#007aff] py-[4px] px-[15px] rounded-full leading-[1.33] text-white text-[15px] leading-[20px] mt-2 z-10">
                Book Now
              </button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InvestmentOption;
